<div class="cu-page">

  <!-- ── Page header ──────────────────────────────────────────── -->
  <div class="cu-header">
    <div class="cu-header__left">
      <div class="cu-header__icon">
        <mat-icon>verified_user</mat-icon>
      </div>
      <div>
        <h1 class="cu-header__title">Usuarios de acceso</h1>
        <p class="cu-header__sub">Gestiona los usuarios que pueden acceder a tu empresa</p>
      </div>
    </div>
  </div>

  <div class="cu-layout">

    <!-- ── LEFT: CREATE + LIST ──────────────────────────────── -->
    <aside class="cu-sidebar">

      <!-- Formulario crear -->
      <div class="cu-card cu-card--create">
        <div class="cu-card__head">
          <mat-icon class="cu-card__head-icon">person_add</mat-icon>
          <span class="cu-card__head-title">Nuevo usuario</span>
        </div>
        <form (ngSubmit)="createUser()" class="cu-form">
          <mat-form-field appearance="outline" class="cu-field">
            <mat-label>Nombre</mat-label>
            <mat-icon matPrefix class="cu-prefix">perm_identity</mat-icon>
            <input matInput [(ngModel)]="newUser.name" name="name" required placeholder="Nombre del usuario">
          </mat-form-field>
          <mat-form-field appearance="outline" class="cu-field">
            <mat-label>Email de acceso</mat-label>
            <mat-icon matPrefix class="cu-prefix">email</mat-icon>
            <input matInput [(ngModel)]="newUser.email" name="email" type="email" required placeholder="usuario@empresa.com">
          </mat-form-field>
          <mat-form-field appearance="outline" class="cu-field">
            <mat-label>Contraseña</mat-label>
            <mat-icon matPrefix class="cu-prefix">lock</mat-icon>
            <input autocomplete="new-password" matInput [(ngModel)]="newUser.password" name="password"
                   [type]="showCreate ? 'text' : 'password'" required placeholder="Mínimo 8 caracteres">
            <button matSuffix mat-icon-button type="button" (click)="showCreate = !showCreate">
              <mat-icon>{{ showCreate ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>
          <button mat-flat-button type="submit" class="cu-btn-primary cu-btn-primary--full">
            <mat-icon>add</mat-icon>
            Crear usuario
          </button>
        </form>
      </div>

      <!-- Lista de usuarios -->
      <div class="cu-card">
        <div class="cu-card__head">
          <mat-icon class="cu-card__head-icon">people</mat-icon>
          <span class="cu-card__head-title">Usuarios ({{ users.length }})</span>
        </div>

        <div *ngIf="users.length === 0" class="cu-empty">
          <mat-icon>person_outline</mat-icon>
          <p>Aún no hay usuarios creados</p>
        </div>

        <ul class="cu-list">
          <li *ngFor="let user of users; trackBy: trackByIndex"
              class="cu-list__item"
              [class.cu-list__item--active]="selectedUser?.id === user.id"
              (click)="editPermissions(user)">
            <div class="cu-avatar">{{ getInitials(user.name) }}</div>
            <div class="cu-list__info">
              <span class="cu-list__name">{{ user.name }}</span>
              <span class="cu-list__email">{{ user.email }}</span>
            </div>
            <mat-icon class="cu-list__arrow">chevron_right</mat-icon>
          </li>
        </ul>
      </div>

    </aside>

    <!-- ── RIGHT: PERMISSIONS PANEL ─────────────────────────── -->
    <main class="cu-main">

      <!-- Empty state -->
      <div *ngIf="!selectedUser" class="cu-empty-main">
        <div class="cu-empty-main__art"><mat-icon>verified_user</mat-icon></div>
        <h2 class="cu-empty-main__title">Selecciona un usuario</h2>
        <p class="cu-empty-main__sub">Haz clic en un usuario para editar sus permisos y opciones.</p>
      </div>

      <!-- Panel de permisos -->
      <div *ngIf="selectedUser" class="cu-perm">

        <!-- Cabecera del usuario -->
        <div class="cu-perm__header">
          <div class="cu-avatar cu-avatar--lg">{{ getInitials(selectedUser.name) }}</div>
          <div>
            <h2 class="cu-perm__name">{{ selectedUser.name }}</h2>
            <p class="cu-perm__email">{{ selectedUser.email }}</p>
          </div>
          <button mat-icon-button class="cu-perm__close" (click)="selectedUser = null" matTooltip="Cerrar">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <!-- Cambio de contraseña -->
        <div *ngIf="!showPasswordForm" class="cu-perm__pw-row">
          <button mat-stroked-button (click)="showPasswordForm = true">
            <mat-icon>vpn_key</mat-icon>
            Cambiar contraseña
          </button>
        </div>
        <div *ngIf="showPasswordForm" class="cu-perm__pw-form">
          <mat-form-field appearance="outline" style="flex:1">
            <mat-label>Nueva contraseña</mat-label>
            <input autocomplete="new-password" matInput [(ngModel)]="newPassword" [type]="showPwChange ? 'text' : 'password'"
                   name="pwchange" placeholder="Nueva contraseña">
            <button matSuffix mat-icon-button type="button" (click)="showPwChange = !showPwChange">
              <mat-icon>{{ showPwChange ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>
          <button mat-flat-button class="cu-btn-primary" (click)="changePassword()" [disabled]="!newPassword">
            <mat-icon>save</mat-icon>
            Guardar
          </button>
          <button mat-stroked-button (click)="cancelPasswordChange()">Cancelar</button>
        </div>

        <mat-divider></mat-divider>

        <!-- Permisos -->
        <form (ngSubmit)="savePermissions()">
          <div class="cu-perm-group">
            <p class="cu-perm__section-title">Permisos de acceso</p>
            <div class="cu-perm-group__label">
              <mat-icon>trending_up</mat-icon>
              <span>Ingresos</span>
            </div>
            <div class="cu-perm-group__items">
              <label *ngFor="let key of ingresoKeys; trackBy: trackByIndex" class="cu-toggle-item">
                <mat-slide-toggle [(ngModel)]="permissions[key]" [name]="key" color="primary">
                  {{ permissionLabels[key] }}
                </mat-slide-toggle>
              </label>
            </div>
          </div>

          <div class="cu-perm-group">
            <div class="cu-perm-group__label">
              <mat-icon>apps</mat-icon>
              <span>Módulos</span>
            </div>
            <div class="cu-perm-group__items">
              <label *ngFor="let key of otherKeys; trackBy: trackByIndex" class="cu-toggle-item">
                <mat-slide-toggle [(ngModel)]="permissions[key]" [name]="key" color="primary">
                  {{ permissionLabels[key] }}
                </mat-slide-toggle>
              </label>
            </div>
          </div>

          <!-- Acciones -->
          <div class="cu-perm__actions">
            <button mat-flat-button type="submit" class="cu-btn-primary">
              <mat-icon>save</mat-icon>
              Guardar permisos
            </button>

            <ng-container *ngIf="!deletePending">
              <button mat-stroked-button type="button" class="cu-btn-danger" (click)="deletePending = selectedUser">
                <mat-icon>delete</mat-icon>
                Eliminar usuario
              </button>
            </ng-container>
            <ng-container *ngIf="deletePending">
              <div class="cu-delete-confirm">
                <span class="cu-delete-confirm__text">
                  <mat-icon>warning</mat-icon>
                  ¿Eliminar a <strong>{{ deletePending.name }}</strong>? Esta acción no se puede deshacer.
                </span>
                <button mat-flat-button color="warn" type="button" (click)="confirmDelete()">Eliminar</button>
                <button mat-stroked-button type="button" (click)="deletePending = null">Cancelar</button>
              </div>
            </ng-container>
          </div>
        </form>

      </div>
    </main>

  </div>
</div>
